/* Scent & Wellness Co. — homepage behaviour: countdowns, carousels, hero slider */
(function () {
  'use strict';

  /* ---------- Countdown ---------- */
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function startCountdown(el) {
    var loopHours = parseFloat(el.dataset.loopHours || '0');
    var target = Date.parse(el.dataset.endsAt || '');
    var fields = {
      days: el.querySelector('[data-unit="days"]'),
      hours: el.querySelector('[data-unit="hours"]'),
      minutes: el.querySelector('[data-unit="minutes"]'),
      seconds: el.querySelector('[data-unit="seconds"]')
    };

    if (isNaN(target) && loopHours <= 0) return;

    function nextTarget() {
      if (loopHours > 0) {
        var span = loopHours * 3600000;
        var base = isNaN(target) ? Date.now() : target;
        var cycles = Math.ceil((Date.now() - base) / span);
        return base + Math.max(cycles, 1) * span;
      }
      return target;
    }

    function tick() {
      var end = target;
      if (isNaN(end) || (end - Date.now() <= 0 && loopHours > 0)) end = nextTarget();

      var left = Math.max(0, end - Date.now());
      var totalSeconds = Math.floor(left / 1000);
      var d = Math.floor(totalSeconds / 86400);
      var h = Math.floor((totalSeconds % 86400) / 3600);
      var m = Math.floor((totalSeconds % 3600) / 60);
      var s = totalSeconds % 60;

      if (fields.days) fields.days.textContent = pad(d);
      if (fields.hours) fields.hours.textContent = pad(h);
      if (fields.minutes) fields.minutes.textContent = pad(m);
      if (fields.seconds) fields.seconds.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Horizontal carousel arrows ---------- */
  function setupCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (!track) return;

    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function refresh() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.hidden = track.scrollLeft <= 2;
      if (next) next.hidden = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollLeft -= step(); });
    if (next) next.addEventListener('click', function () { track.scrollLeft += step(); });
    track.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    refresh();
  }

  /* ---------- Hero slider ---------- */
  function setupHero(root) {
    var track = root.querySelector('[data-hero-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    var interval = parseInt(root.dataset.autoplay || '0', 10);
    var timer = null;

    function goTo(index) {
      track.scrollTo({
        left: track.clientWidth * index,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    function current() {
      return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    }

    function sync() {
      var i = current();
      dots.forEach(function (dot, index) {
        dot.setAttribute('aria-current', index === i ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        goTo(index);
        restart();
      });
    });

    track.addEventListener('scroll', sync, { passive: true });

    function restart() {
      if (timer) clearInterval(timer);
      if (!interval || slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () {
        goTo((current() + 1) % slides.length);
      }, interval);
    }

    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', restart);

    sync();
    restart();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-countdown]').forEach(startCountdown);
    (scope || document).querySelectorAll('[data-carousel]').forEach(setupCarousel);
    (scope || document).querySelectorAll('[data-hero]').forEach(setupHero);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });

  /* Re-init when a section is re-rendered inside the Shopify theme editor */
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

/* desktop par hover se dropdown khule */
(function () {
  if (!window.matchMedia('(min-width: 990px)').matches) return;

  document.querySelectorAll('.header__inline-menu details').forEach(function (d) {
    d.addEventListener('mouseenter', function () { d.setAttribute('open', ''); });
    d.addEventListener('mouseleave', function () { d.removeAttribute('open'); });
  });
})();

/* hero: image zoom poora ho to agli slide, hover par sab ruk jaye */
(function () {
  function setup(root) {
    if (!root || root.dataset.swZoom) return;
    var track = root.querySelector('[data-hero-track]');
    if (!track || !track.children.length) return;
    root.dataset.swZoom = '1';

    var slides = Array.prototype.slice.call(track.children);
    var current = -1;
    var settle;

    function index() {
      return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    }

    function start(i) {
      if (i === current) return;
      var old = slides[current];
      current = i;
      var slide = slides[i];
      if (!slide) return;
      slide.classList.remove('is-zooming');
      void slide.offsetWidth;
      slide.classList.add('is-zooming');
      if (old && old !== slide) {
        setTimeout(function () { if (slides[current] !== old) old.classList.remove('is-zooming'); }, 900);
      }
    }

    slides.forEach(function (slide, n) {
      slide.addEventListener('animationend', function (e) {
        if (e.target !== slide || e.animationName !== 'sw-hero-timer') return;
        if (n !== current || slides.length < 2) return;
        var next = (n + 1) % slides.length;
        var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left: track.clientWidth * next, behavior: smooth ? 'smooth' : 'auto' });
      });
    });

    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () { start(index()); }, 120);
    }, { passive: true });

    root.addEventListener('mouseenter', function () { root.classList.add('is-paused'); });
    root.addEventListener('mouseleave', function () { root.classList.remove('is-paused'); });

    start(index());
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-hero]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
